//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { lighten, makeStyles, withStyles } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import { Switch, Route } from "react-router-dom";

//Child Components
import Billing1 from './billing'
import Billing2 from './billingHistory'
import Billing3 from './subscriptions'
import MiddleHeader from "../middleHeader/middleHeader";

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";

//Custom Css + Images
import "./billing.css";


//React Router
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";

//translation
import {useTranslation} from 'react-i18next';

//react redux
import { useSelector, useDispatch } from "react-redux";



const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    maxHeight: "53vh",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

const AntTabs = withStyles({
    root: {
      backgroundColor: "#ffffff",
      color: "#222",
    },
    indicator: {
      backgroundColor:'#1a73e8'
      // display:'none'
    },
  })(Tabs);



function BillingNav() {
  const {t} = useTranslation();
  const language = useSelector(state=>state.languageReducer.language)
  const classes = useStyles();
  let history = useHistory();
  const [value, setValue] = React.useState(0);


  React.useEffect(() => {
    if (window.location.pathname == "/billing/subscriptions") {
      setValue(2);
    } else if (window.location.pathname == "/billing/history") {
      setValue(1);
    } else {
      setValue(0);
    }
  }, []);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

 
  return <>
      <MiddleHeader />
      <div className="" style={{ padding: "20px", overflow: "auto", backgroundColor: "#eaf7fe" }}>
        <div>
          {/* ================================== Recently Created Templates  ========================= */}
          <Grid container justifyContent="center" alignItems="center" className="scrollHidden shadow" style={{ backgroundColor: "white", padding: "0px", borderRadius: "5px", marginTop: "0px", overflowY: "hidden", width: "100%", height: "100%" }}>
            <Grid item xs={12} md={12} lg={12} style={{ padding: "5px 20px 0px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: Colors.globalColor4 }}>
              <Grid container justify="space-between" alignItems="center">
                <Grid item xs={12} md={12} lg={8}>
                  {/* For Web */}
                  {window.innerWidth > 700 && <AntTabs className="scheduleTabHeader" style={{ color: Colors.buttonTextColor }} value={value} onChange={handleChange} aria-label="simple tabs example">
                      <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 0 ? Colors.globalColor9 : "transparent", color: value == 0 ? "#1a73e8" : "black" }} label={t("License Information")} {...a11yProps(0)} component={Link} to="/billing" />
                      <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontWeight: "bold", fontSize: 12, backgroundColor: value == 1 ? Colors.globalColor9 : "transparent", color: value == 1 ? "#1a73e8" : "black" }} label={t("Invoice History")} {...a11yProps(1)} component={Link} to="/billing/history" />
                      <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 2 ? Colors.globalColor9 : "transparent", color: value == 2 ? "#1a73e8" : "black" }} label="Subscriptions" {...a11yProps(2)} component={Link} to="/billing/subscriptions" />
                    </AntTabs>}
                  {/* For Tab */}
                  {window.innerWidth > 500 && window.innerWidth <= 700 && <AntTabs className="scheduleTabHeader2" style={{ color: Colors.buttonTextColor }} value={value} onChange={handleChange} aria-label="simple tabs example">
                      <Tab className="templateTab2" style={{ margin: "5px 0px", textTransform: "uppercase", fontSize: 12, fontWeight: "bold", backgroundColor: value == 0 ? Colors.globalColor9 : "transparent", color: value == 0 ? Colors.globalColor8 : "black" }} label={t("License Information")} {...a11yProps(0)} component={Link} to="/billing" />
                      <Tab className="templateTab2" style={{ margin: "5px 0px", textTransform: "uppercase", fontWeight: "bold", fontSize: 12, backgroundColor: value == 1 ? Colors.globalColor9 : "transparent", color: value == 1 ? Colors.globalColor8 : "black" }} label={t("Invoice History")} {...a11yProps(1)} component={Link} to="/billing/history" />
                      <Tab className="templateTab2" style={{ margin: "5px 0px", textTransform: "uppercase", fontSize: 12, fontWeight: "bold", borderRight: "1px solid #dadada", backgroundColor: value == 2 ? Colors.globalColor9 : "transparent", color: value == 2 ? Colors.globalColor8 : "black" }} label="Subscriptions" {...a11yProps(2)} component={Link} to="/billing/subscriptions" />
                    </AntTabs>}
                  {/* For Mobile */}
                  {window.innerWidth <= 500 && <AntTabs className="scheduleTabHeader" style={{ color: Colors.buttonTextColor }} value={value} onChange={handleChange} aria-label="simple tabs example">
                      <Tab className="templateTab3" style={{ margin : "0px", textTransform: "uppercase", fontSize: 10, fontWeight: "bold", backgroundColor: value == 0 ? Colors.globalColor9 : "transparent", color: value == 0 ? Colors.globalColor8 : "black" }} label={t("License Information")} {...a11yProps(0)} component={Link} to="/billing" />
                      <Tab className="templateTab3" style={{ margin: "0px", textTransform: "uppercase",  fontWeight: "bold", fontSize: 10, backgroundColor: value == 1 ? Colors.globalColor9 : "transparent", color: value == 1 ? Colors.globalColor8 : "black" }} label={t("Invoice History")} {...a11yProps(1)} component={Link} to="/billing/history" />
                      <Tab className="templateTab3" style={{ margin: "5px 0px", textTransform: "uppercase", fontSize: 10, fontWeight: "bold", borderRight: "1px solid #dadada", backgroundColor: value == 2 ? Colors.globalColor9 : "transparent", color: value == 2 ? Colors.globalColor8 : "black" }} label="Subscriptions" {...a11yProps(2)} component={Link} to="/billing/subscriptions" />
                    </AntTabs>}
                </Grid>
                <Grid item xs={12} md={12} lg={2} style={{textAlign:language == "ar" ? 'left' :'right'}}>
                  <Button style={{ width: window.innerWidth < 500 ? "100%" : "auto", marginBottom:"5px", paddingRight: "2px", paddingLeft: "2px", marginRight: window.innerWidth > 700 && "20px" }} className="ctBtn" onClick={()=>history.push("/update_package")}>
                    {t("Change Plan")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            <div style={{ width: "100%" }}>
              <Switch>
                <Route exact path="/billing/" component={Billing1} />
                <Route exact path="/billing/history" component={Billing2} />
                <Route exact path="/billing/subscriptions" component={Billing3} />
              </Switch>
            </div>
          </Grid>
        </div>
      </div>
    </>;
}

const comp1 = () => {
  return <h1>Comp1</h1>;
};

const comp2 = () => {
  return <h1>Comp2</h1>;
};

const comp3 = () => {
  return <h1>Comp3</h1>;
};
const comp4 = () => {
    return <h1>Comp4</h1>;
  };
export default BillingNav;
